import TierComponent from "./TierComponent";
import { Festival } from "../Types/Festival";
import '../css/tiers.css';

type FestivalComponentProps = {
  festival: Festival;
};

function FestivalComponent({ festival }: FestivalComponentProps) {
  return (
    <section className="festivalCalc" aria-label="Festival ticket tiers">
      <div>
        <h4>
          {festival.name} - (last updated: {festival.lastUpdated})
        </h4>
        <span>Excess Value is calculated as the sum of your perk values minus the difference between the ticket level's cost and the previous level's cost.</span>
        <div id="gaDiv">
          <span className="tierHeader" title={festival.gaTierHistory}>
            GA Cost (with fees): {festival.gaPrice}
          </span>
        </div>
        <div className="tiersRow">
          {festival.ticketTiers.map((tier) => (
            <TierComponent key={tier.level} tier={tier} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FestivalComponent;